export const sessionTimeout = () => {
  if (typeof window.millisecondsToSessionExpiration !== "undefined" && window.millisecondsToSessionExpiration < 2147483647) {
    setTimeout(() => {
      window.location.pathname = '/users/sign_in';
    }, window.millisecondsToSessionExpiration);
  }
};
